/**
 * Utility to resolve API URLs based on the current domain.
 * Supports China proxy addresses for ecdis-link.net domain.
 */

const isChinaProxy = () => {
    return typeof window !== 'undefined' && window.location.hostname.endsWith('ecdis-link.net');
};

/**
 * mwend API (Primary API)
 * Direct: https://mwend.bgeo.fi
 * Proxy: https://mwend.ecdis-link.net
 */
export const getMwendBaseUrl = () => {
    if (isChinaProxy()) {
        return 'https://mwend.ecdis-link.net';
    }
    const protocol = process.env.VUE_APP_API_PROTOCOL || 'https://';
    const host = process.env.VUE_APP_API_BASE_URL || 'mwend.bgeo.fi';
    return protocol + host;
};

/**
 * elblack API (Admin/AIS/Catalog)
 * Direct: https://elblack.bgeo.fi
 * Proxy: https://elblack.ecdis-link.net
 */
export const getElblackBaseUrl = () => {
    if (isChinaProxy()) {
        return 'https://elblack.ecdis-link.net';
    }
    return 'https://elblack.bgeo.fi';
};

/**
 * mkart API (Chart downloads)
 * Direct: https://mkart-api.bgeo.fi
 * Proxy: https://mkart-api.ecdis-link.net
 */
export const getMkartBaseUrl = () => {
    if (isChinaProxy()) {
        return 'https://mkart-api.ecdis-link.net';
    }
    return 'https://mkart-api.bgeo.fi';
};
